import { useState } from 'react';
import { collection, query, orderBy, onSnapshot, DocumentData } from "firebase/firestore";
import { auth, db } from '../../service/index';
import { doc, getDoc } from "firebase/firestore";
import { where, getDocs } from "firebase/firestore";
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import IProduct from '../../types/IProduct';
import { ButtonContainer, PickListContainer } from './stylesPickList';
import { dateConverter, handleDeleteList } from '../../service/api';
import CreateNewList from '../CreateNewList/CreateNewList';
import { v4 as uuidv4 } from 'uuid';


export default function PickList() {

    let listsArray: number | DocumentData[] = []
    const [lists, setLists] = useState(listsArray);
    const [selectedList, setSelectedList] = useState("");
    
    

    async function getData() {
        const q = query(collection(db, "lists"), where("user_id", "==", auth.currentUser?.uid)); 
        let array: DocumentData[] = [];
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            let list = doc.data()
            array.push({ ...list, id: doc.id })
        });
        setLists(array)
    }



    return (
        <>
            <PickListContainer>
                <br></br>
                <h2>Selecione uma de suas listas para iniciar as compras: </h2>
                <Accordion>


                    {lists && lists.map(item => {
                        return (
                            <Accordion.Item eventKey={item.id} key={uuidv4()}>
                                <Accordion.Header>
                                    <input type="radio" name={"selectedList"} id={item.id} value={item.id} onChange={e => {
                                        setSelectedList(e.target.value)
                                    }} />
                                    <span>{item.title}</span>
                                    <span>{item.createdAt ? dateConverter(item.createdAt.toDate()) : "------"}</span>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <ul>
                                        {item.items && item.items.map((item: IProduct) => {
                                            return (
                                                <li className={item.checked ? "checked" : ""}>{item.name}</li>
                                            );
                                        })}
                                    </ul>
                                    <ButtonContainer>

                                        <Button variant="danger" onClick={() => {
                                            handleDeleteList(item.id);
                                            getData();
                                        }}>Deletar lista</Button>
                                        <Button><Link to={`/compra-da-vez/${item.id}`}>Editar Lista</Link></Button>
                                    </ButtonContainer>
                                </Accordion.Body>
                            </Accordion.Item>

                        )
                    })}

                </Accordion>
                
            </PickListContainer>

            <ButtonContainer>
                <Button variant="secondary" onClick={(getData)}>Mostrar minhas listas</Button>
                <CreateNewList />
                {selectedList && <Button variant="dark"><Link to={`/compra-da-vez/${selectedList}`}>Abra a lista selecionada</Link></Button>}
            </ButtonContainer>



        </>
    );
}